var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.977,
    height: 19.621,
    viewBox: "0 0 19.977 19.621",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Search",
    transform: "translate(1.5 1.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_65",
    "data-name": "Ellipse 65",
    cx: 7.156,
    cy: 7,
    rx: 7.156,
    ry: 7,
    fill: "none",
    stroke: "#446fa2",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_109",
    "data-name": "Vector 109",
    d: "M3.067,3,0,0",
    transform: "translate(13.289 13)",
    fill: "none",
    stroke: "#446fa2",
    strokeLinecap: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.2304060b13cc78f5d972822db401e120.svg";
export { ForwardRef as ReactComponent };